import { typeBrachOffices } from "./branchOffices"
import { queryBranchOffice } from "./queries/queryBranchOffice"
import { queryBranchOffices } from "./queries/queryBranchOffices"

const branchOfficeSchema = {
  types: [typeBrachOffices],
  resolvers: {
    Query: {
      ...queryBranchOffice,
      ...queryBranchOffices,
    },
    Mutation: {},
  },
}

export default branchOfficeSchema
